import script from "./TagsBasic.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsBasic.vue?vue&type=script&setup=true&lang=js"

import "./TagsBasic.vue?vue&type=style&index=0&id=0f5a81df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5a81df"]])

export default __exports__